module.exports = __webpack_public_path__ + "static/media/techton_splash_2.e68ab7fb.webp";